import axios from './axios';

const BASE = '/api/settings/privacy';

export const getPrivacyDashboard = async () => axios.get(BASE);
export const getPrivacyExports = async () => axios.get(`${BASE}/exports`);
export const requestFullPrivacyExport = async () => axios.post(`${BASE}/export/full`);
export const requestFinancialPrivacyExport = async () => axios.post(`${BASE}/export/financial`);
export const requestAuditLogPrivacyExport = async () => axios.post(`${BASE}/export/audit-log`);
export const downloadPrivacyExport = async (downloadUrl) => axios.get(downloadUrl, { responseType: 'blob' });
export const requestAccountDeletion = async (payload) => axios.post(`${BASE}/request-deletion`, payload);
export const cancelAccountDeletion = async () => axios.post(`${BASE}/cancel-deletion`);

// New Compliance Endpoints
export const deactivateAccount = async (payload) => axios.post(`${BASE}/deactivate`, payload);
export const deleteAccountImmediately = async (payload) => axios.post(`${BASE}/delete-immediately`, payload);
export const getPrivacyConfig = async () => axios.get(`${BASE}/config`);
